import { render, staticRenderFns } from "./VideoInstruction.vue?vue&type=template&id=24bc6c78&"
import script from "./VideoInstruction.vue?vue&type=script&lang=ts&"
export * from "./VideoInstruction.vue?vue&type=script&lang=ts&"
import style0 from "./VideoInstruction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VFileInput,VIcon,VSnackbar})
